import React from "react";
import Link from "gatsby-link";
import StoreLinks from "./storeLinks";

const Header = () => (
  <div className="header">
    <div className="header-container">
      <Link to="/" className="header-home">
        Code Sculpture
      </Link>
      <p className="description">
        The iPhone and iPad App to create 3D Art from Simple Rules{" "}
        <a href="https://complexview.com">(from James Porter)</a>.
      </p>

      <div className="header-links">
        <Link to="/" exact={true} activeClassName="active">
          Introduction
        </Link>
        <Link to="/editor" activeClassName="active">
          Editor
        </Link>
        <Link to="/lessons" activeClassName="active">
          Video Lessons
        </Link>
      </div>

      <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/code-sculpture/id1286544769" />
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js